import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router, NavigationEnd} from '@angular/router';
import {LocalStorageService} from 'ngx-webstorage';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  public subHeaderShow = false;
  public hideOnReset = false;
  code: any;
  private sub: any;
  showAppItemDetailHeader = false;
  showCalendar = true;
  showCategories = false;
  showMyCart = false;
  editOrderAddingAnotherItem = false;

  ngOnInit(): void {
    this.sub = this.activeRoute.queryParams.subscribe(params => {
        this.code = params['code'];
      });
    // tslint:disable-next-line:max-line-length
    this.localSt.retrieve('editOrderAddingAnotherItem') ? this.editOrderAddingAnotherItem = this.localSt.retrieve('editOrderAddingAnotherItem') : this.editOrderAddingAnotherItem = false;
    this.localSt.observe('editOrderAddingAnotherItem').subscribe((editOrderAddingAnotherItem) => {
      this.editOrderAddingAnotherItem = !!editOrderAddingAnotherItem;
    });
  }

  constructor(router: Router,
              private activeRoute: ActivatedRoute,
              private localSt: LocalStorageService) {

    // this.showMyCart = this.localSt.retrieve('showMyCart');
    this.localSt.observe('showMyCart').subscribe((res) => {
      setTimeout(() => this.showMyCart = res, 0);
    });
    // as router event is subscribe here,
    // decide here which component should show and which should hide based on URL

    router.events.subscribe((route) => {
      if (route instanceof NavigationEnd) {
        if (route.url === '/' && route.url) {
          this.subHeaderShow = false;
          this.showCalendar = true;
          this.showCategories = false;
        } else if (route.url) {
          // this.subHeaderShow = true;
        }

        // show hide component on category item listing page
        if (route.url && route.url.indexOf('/items/') > -1) {
          this.subHeaderShow = false;
          this.showCategories = true;
          this.showCalendar = true;
        } else {
        }

        // show hide items on item details page
        if (route.url && route.url.indexOf('/items/detail/') > -1) {
          this.showAppItemDetailHeader = true;
          this.subHeaderShow = false;
          this.showCategories = false;
        } else {
          this.showAppItemDetailHeader = false;
        }

        if (
          route.url === '/user/reset-password?code=' + this.code && route.url ||
          route.url === '/user/reset-password-expired' && route.url ||
          route.url === '/no-internet' && route.url
        ) {
          this.hideOnReset = false;
          this.showCalendar = false;
          this.subHeaderShow = true;
        } else if (route.url) {
          this.hideOnReset = true;
        }

        // Show Hide modules on payment methods
        if (route.url === '/payments' ||
          route.url === '/payments/list' ||
          route.url === '/payments/add-new-card' ||
          route.url === '/payments/edit-card') {
          this.showCalendar = false;
          this.showCategories = false;
          this.subHeaderShow = true;
        }

        // Show Hide modules on Address module
        if (route.url === '/address-book/list' ||
          route.url === '/address-book/add-new-address' ||
          route.url === '/address-book/edit-address') {
          this.showCalendar = false;
          this.showCategories = false;
          this.subHeaderShow = true;
        }

        // web pages
        if (route.url === '/about' ||
          route.url === '/how-to-order' ||
          route.url === '/faq' ||
          route.url === '/terms' ||
          route.url === '/orders/list' ||
          route.url === '/user/account-info' ||
          route.url === '/user/update-password' ||
          route.url === '/search' ||
          route.url === '/checkout/review-order' ||
          route.url === '/orders/receipt/' + this.localSt.retrieve('orderNumber') ||
          route.url === '/orders/current/' + this.localSt.retrieve('orderNumber') ||
          route.url === '/orders/edit/' + this.localSt.retrieve('orderNumber') ||
          route.url === '/orders/past/' + this.localSt.retrieve('orderNumber')
          ) {
          this.showCalendar = false;
          this.subHeaderShow = true;
          this.showCategories = false;
        }
        if (route.url !== '/search') {
          this.localSt.store('hideSearchBar', '1');
        }

        // // if user wants to navigate in app , destroy current state of checkout
        // if (route.url && route.url.indexOf('/checkout/') === -1) {
        //   this.localSt.clear('activeCheckoutStep');
        //   this.localSt.clear('doneCheckoutSteps');
        // }
      }
    });

    this.localSt.observe('pastOrderAgain').subscribe((pastOrderAgain) => {
      if (pastOrderAgain) { this.showCalendar = true; this.subHeaderShow = false; }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts